/**
 * Logos Swiper Frontend JavaScript
 *
 * Initializes Swiper for logo carousels with smooth animations and responsive behavior
 *
 * @version 1.0.0
 */

(function () {
	"use strict";

	/**
	 * Initialize Logos Swiper
	 */
	function initLogosSwiper() {
		const logosSwipers = document.querySelectorAll('.logos-swiper');

		logosSwipers.forEach((swiperElement) => {
			try {
				// Get configuration from data attribute
				const configData = swiperElement.dataset.swiperConfig;
				if (!configData) {
					console.warn('Logos Swiper: No configuration found');
					return;
				}

				const config = JSON.parse(configData);

				// Wait for Swiper to be available
				if (typeof Swiper === 'undefined') {
					console.warn('Logos Swiper: Swiper library not found');
					return;
				}

				// Check if we have enough slides for looping
				const slides = swiperElement.querySelectorAll('.swiper-slide');
				const slidesPerView = config.slidesPerView || 2;
				
				
				
				// Initialize Swiper with ultra-smooth autoplay
				const swiper = new Swiper(swiperElement, {
					slidesPerView: config.slidesPerView || 2,
					spaceBetween: config.spaceBetween || 30,
					loop: true,
				
					// Continuous smooth movement autoplay
					autoplay: {
						delay: 0, // No delay - continuous movement
						disableOnInteraction: false, // Never stop on interaction
					},
					
					// Continuous smooth movement settings
					speed: 1000, // Very slow, smooth movement
					effect: 'slide', // Use slide effect for smoothness
					grabCursor: true, // Show grab cursor
					
					// Enhanced easing for smoother animations
					cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', // Smooth easing
					
					navigation: config.navigation ? {
						nextEl: swiperElement.parentElement.querySelector(config.navigation.nextEl),
						prevEl: swiperElement.parentElement.querySelector(config.navigation.prevEl),
					} : false,
					pagination: config.pagination ? {
						el: swiperElement.querySelector(config.pagination.el),
						clickable: config.pagination.clickable || true,
					} : false,
					breakpoints: config.breakpoints || {
						768: {
							slidesPerView: 3,
						},
						1024: {
							slidesPerView: 5,
						},
					},
					
					// Performance optimizations for smooth autoplay
					preloadImages: true, // Preload for smoother transitions
					lazy: false, // Disable lazy loading for smoother autoplay
					
					// Accessibility
					a11y: {
						prevSlideMessage: 'Previous logo',
						nextSlideMessage: 'Next logo',
						firstSlideMessage: 'This is the first logo',
						lastSlideMessage: 'This is the last logo',
					},
					
					// Responsive behavior
					watchOverflow: true,
					watchSlidesProgress: true,
					watchSlidesVisibility: true,
					
					// Additional smooth autoplay settings
					allowTouchMove: true, // Allow touch/swipe
					resistance: true, // Enable resistance at edges
					resistanceRatio: 0.85, // Resistance ratio
					
					// Observer for dynamic content changes
					observer: true,
					observeParents: true,
					observeSlideChildren: true,
				});

				// Store reference for external access
				swiperElement.swiper = swiper;

				// Force autoplay to start
				if (swiper.autoplay) {
					swiper.autoplay.start();
				}

			} catch (error) {
				console.error('Logos Swiper: Initialization failed:', error);
			}
		});
	}

	/**
	 * Wait for DOM to be ready
	 */
	function init() {
		// Initialize on page load
		initLogosSwiper();

		// Re-initialize on window resize (debounced)
		let resizeTimeout;
		window.addEventListener('resize', function() {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(initLogosSwiper, 250);
		});
	}

	/**
	 * Auto-initialize
	 */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	/**
	 * Export for external use
	 */
	window.initLogosSwiper = initLogosSwiper;

})();
